class UserLoginError extends Error {
  constructor(message: string) {
    super(message);
    this.message = message;
    this.name = 'UserLoginError';
  }
}

export { UserLoginError };
